/*
* This class aims 
*   - listen cart and if there is changed cart items, update the server cart status of customer.
*   - when user login if he/she had had a cart before, clear current cart and restore it his former cart
*/
const CartAccount = function () {
    this.getNativeShopifyCart = () => {
        return fetch(window.Shopify.routes.root + 'cart.js', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        })
            .then(response => {
                return response.json();
            })
            .catch((error) => {
                console.error('Error:', error);
            });
    }
    this.setNativeShopifyCart = (payload) => {
        // console.log('Cart-account Class: set new cart from metafield object');
        return fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
        })
            .then(response => {
                return response.json();
            })
            .catch((error) => {
                console.error('Error:', error);
            });
    }
    this.clearShopifyCart = () => {
        return fetch(window.Shopify.routes.root + 'cart/clear.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            }
        })
            .then(response => {
                return response.json();
            })
            .catch((error) => {
                console.error('Error:', error);
            });
    }
    // Send current shopify cart object to karaca API and save customer's current cart
    this.sendCartAccount = (cartObject) => {
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        myHeaders.append("store-id", store_id);


        var raw = JSON.stringify(cartObject);

        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: raw,
            redirect: 'follow'
        };
        fetch(service_url +"api/v1/customer/metafield/cart", requestOptions)

            .then(response => response.json())
            .then(result => {
                if (result.error) {
                    // console.log('Customer Cart metafield update ERROR')
                    return '';
                }
                if(screen.width < 440){
                    document.getElementById("js-go").innerHTML = $("#main-number").html();
                }
                // console.log('Customer Cart metafield update response')
            })
            // .catch(error => console.log('error', error));
    }

    // Get current cart and send it to server
    this.setAlignCarts = (customerId, forced) => {
        this.getNativeShopifyCart()
            .then(response => {
                // console.log('The current cart object is ', response);
                let cartObject = {
                    customer_id: customerId,
                    cart: []
                }
                if (response?.items) {
                    cartObject.cart = response.items.map(item => {
                        return {
                            id: item.id,
                            quantity: item.quantity
                        }
                    })
                }
                this.sendCartAccount(cartObject);
            });
    }
    this.setEmpty = (customerId) => {
        let cartObject = {
            customer_id: customerId,
            cart: []
        };
        this.sendCartAccount(cartObject);
    }
    this.updateCartViaMetafield = async (metafieldCartObject) => {
        const nativeCart = await this.getNativeShopifyCart();

        if (nativeCart?.items?.length) {
            // console.log('The current cart object is ', response);
            let cartObjectCurrent = {
                customer_id: customerId,
                cart: []
            }
            if (nativeCart?.items) {
                cartObjectCurrent.cart = nativeCart.items.map(item => {
                    return {
                        id: item.id,
                        quantity: item.quantity
                    }
                })
            }
            this.sendCartAccount(cartObjectCurrent);

            return;
        }

        let payload = []
        if (Array.isArray(metafieldCartObject)) {
            payload = {
                items: [...metafieldCartObject]
            }
        }
        // console.log('Cart-account Class: new cart object is ready',payload);
        return this.clearShopifyCart()
            .then(() => {

                // console.log('Cart-account Class: the previous cart is cleared.');
                return this.setNativeShopifyCart(payload);
            })
    }
    this.startListening = (customerId, cartUpdateTargetElements) => {
        const config = { attributes: false, childList: true, subtree: false };
        const callback = (mutationList, observer) => {
            for (const mutation of mutationList) {
                if (mutation.type === "childList") {
                    this.setAlignCarts(customerId);
                }
            }
        };

        setTimeout(() => {
            const observer = new MutationObserver(callback);
            observer.observe(cartUpdateTargetElements, config);
        }, 2000);
    }
}